 <div>
  <div
    class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl xl:col-span-2">
    <div class="p-6">
      <div
        class="mr-4 truncate text-lg font-medium leading-6 tracking-tight">
        {{'TradeIn' | transloco}}
      </div>
    </div>
    <div class="mx-6 overflow-x-auto">
      <table
        class="w-full bg-transparent"
        mat-table
        matSort
        [dataSource]="dataSource()"
        #tradeInVehiclesTable>

        <ng-container matColumnDef="Vin number and model">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            {{'VinnumberandCarModel' | transloco}}
          </th>
          <td mat-cell *matCellDef="let car">
            <span
              class="text-secondary whitespace-nowrap pr-6 text-sm font-medium">
              {{ car.fullName }}
            </span>
            <br />
            <span class="whitespace-nowrap pr-6">
              {{ car.internNumber }}</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="Status">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            Status
          </th>
          <td mat-cell *matCellDef="let car">
            <span class="whitespace-nowrap pr-6">
              {{ car.vehicleStatus | transloco }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Contract link">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef>
            {{'Contract' | transloco}} link
          </th>
          <td mat-cell *matCellDef="let vehicle">
            <div class="flex items-center">
              <button
                mat-icon-button
                color="accent"
                class="self-end"
                (click)="openDetails(vehicle.contractId)">
                <mat-icon
                  [svgIcon]="'heroicons_outline:link'"></mat-icon>
              </button>
            </div>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"
          class="bg-gray-100 dark:bg-gray-700"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <app-pagination
        [pagination]="purchaseAdminService.tradeInsParams().pagination"
        (paginationChanged)="getVehicles()"></app-pagination>
    </div>
  </div>
</div>

